import { checkProductLength, replacePriceSymbol } from '../../Utils/helper';

import { fireEvent } from '../../Utils/fireEvent';

export const clickedCardEvent = (
  sectionName,
  sectionId,
  cardName,
  cardId,
  url,
) => {
  fireEvent({
    category: 'clicked_card_in_myloshop',
    section_name: sectionName,
    section_id: sectionId,
    card_name: cardName,
    card_id: cardId,
    page_url: url,
    shape: 'PRODUCT',
    screen_name: 'maternity_landing_page',
  });
};
export const servedSectionEvent = (sectionName, sectionId, cardIds, url) => {
  fireEvent({
    category: 'served_section_in_myloshop',
    screen_name: 'maternity_landing_page',
    shape: 'SECTION',
    section_name: sectionName,
    section_id: sectionId,
    card_ids: cardIds,
    page_url: url,
  });
};
export const clickedCtaEvent = (sku_name, sku_id, url, ctaText) => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: 'maternity_landing_page',
    parent: 'select_size',
    path_name: url,
    id: sku_id,
    sku_name: sku_name,
    cta: ctaText,
  });
};
export const viewedSizePopup = (sku_name, sku_id, url) => {
  fireEvent({
    category: 'viewed_popup',
    screen_name: 'maternity_landing_page',
    parent: 'select_size',
    path_name: url,
    id: sku_id,
    sku_name: sku_name,
  });
};
export const discardSizePopup = (sku_name, sku_id) => {
  fireEvent({
    category: 'discard_popup',
    screen_name: 'maternity_landing_page',
    parent: 'select_size',
    path_name: window.location.pathname?.substring(0, 99),
    id: sku_id,
    sku_name: sku_name,
  });
};
export const clickedAddToCart = (skuId, cardName, eventsData) => {
  const { sectionId, sectionName, productName, productNickname, sellingPrice } =
    eventsData;
  const nickname = checkProductLength(productNickname);

  const price = replacePriceSymbol(sellingPrice);
  fireEvent({
    category: 'clicked_add_to_cart',
    screen_name: 'maternity_landing_page',
    shape: 'PRODUCT',
    section_name: sectionName,
    section_id: sectionId,
    id: skuId,
    sku_name: productName,
    sku_nickname: nickname,
    card_name: cardName,
    card_id: skuId,
    selling_price: price,
    page_url: window.location.pathname.substring(0, 99),
  });
};
export const viewedMaternityPage = (url) => {
  fireEvent({
    category: 'viewed_general_screen',
    screen_name: 'maternity_landing_page',
    page_url: url,
  });
};
